const upperFirst = (s: string) => {
  return s.slice(0, 1).toUpperCase() + s.slice(1, s.length);
};

export const snakeToPascalCase = (s: string): string => {
  return s
    .split('_')
    .map(str => {
      return upperFirst(str.split('/').map(upperFirst).join('/'));
    })
    .join('');
};

export const toTitleCase = (phrase: string): string => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
